module.exports = __webpack_public_path__ + "img/Home21.b41d022b.jpg";